export default __webpack_public_path__ + "static/instagram-edb90ecc706a7a25542b1a3c9c0a9f75.png";